import React from 'react';

const AppSubRightSection = React.memo(({}) => {
  const imagesSubRightSection = [];

  return (
    <div className="app-sub-right-section-container">
      <div className="app-sub-right-section">
        {imagesSubRightSection.map((image) => (
          <div key={image.id} className="image-container">
            <img
              className="app-sub-right-img"
              src={image.image}
              alt={`Image ${image.id}`}
              onClick={image.onclick}
              style={{ cursor: image.onclick ? 'pointer' : 'default' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default AppSubRightSection;
